import * as S from "../../Style/Page/Hat.style.js";
import { Link } from "react-router-dom";
import { ReactComponent as Home } from "../../assets/icon/home.svg";
import Arrow from "../../assets/icon/lnb_arrow.png";
import PageTitle from "../../Component/PageTitle.js";
// const Factory1 = `${process.env.REACT_APP_ASSET_BASE || ""}/static/media/09. 스리랑카 1공장.7a623a2672ef2a8728af.jpg`;
import Factory1 from "../../assets/ProductionCorporation/스리랑카 공장.png";
const Factory2 = `${process.env.REACT_APP_ASSET_BASE || ""}/static/media/10. 스리랑카 3공장.cea6322c7eeedbf1a3f5.jpg`;
// const Hat1 = `${process.env.REACT_APP_ASSET_BASE || ""}/static/media/11. 스리랑카 모자1.4199d21eaf409e1247a9.png`;
const Hat2 = `${process.env.REACT_APP_ASSET_BASE || ""}/static/media/12. 스리랑카 모자2.459f7959394d6a9fe054.png`;
import Hat1 from "../../assets/ProductionCorporation/스리랑카 모자1.png";
import HatPageTopLine from "../../Component/HatPageTopLine.js";
const ProductionCorporation = () => {
  return (
    <S.Page className={localStorage.getItem("language")}>
      <HatPageTopLine name={"모자사업"} />
      <section className="section" id="hat-introduce-section">
        <S.PageNavidation>
          <Link to="/" className="logo">
            <Home />
          </Link>
          <S.Nav height={"364px"}>
            <S.NavItem>
              <Link to="/HatBusiness/Introduce">
                <div className="kor">모자사업</div>
                <div className="eng">Hat Business</div>
              </Link>
            </S.NavItem>

            <div className="open-list">
              <S.NavItem className="list-inner-item">
                <Link to="/HatBusiness/Introduce">
                  <div className="kor">모자사업</div>
                  <div className="eng">Hat Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/ForkLiftBusiness/Introduce">
                  <div className="kor">지게차사업</div>
                  <div className="eng">Fork Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/CarBusiness/introduce">
                  <div className="kor">자동차사업</div>
                  <div className="eng">Car Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/BusBusiness/OverseasBus">
                  <div className="kor">버스사업</div>
                  <div className="eng">Bus Business</div>
                </Link>
              </S.NavItem>

              <S.NavItem className="list-inner-item">
                <Link to="/GeneralBusiness/introduce">
                  <div className="kor">일반사업</div>
                  <div className="eng">General Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/SocialBusiness/SocialService">
                  <div className="kor">사회사업</div>
                  <div className="eng">Social Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/WBH/WBH">WBH</Link>
              </S.NavItem>
            </div>
            <img src={Arrow} className="down-arrow" alt="" />
          </S.Nav>

          <S.Nav height={"260px"}>
            <S.NavItem>
              <Link to="/HatBusiness/ProductionCorporation">
                <div className="kor">직경영사업장</div>
                <div className="eng">Direct Management Affiliates</div>
              </Link>
            </S.NavItem>
            <div className="open-list">
              <S.NavItem className="list-inner-item">
                <Link to="/HatBusiness/Introduce">
                  <div className="kor">모자사업</div>
                  <div className="eng">Hat Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/HatBusiness/KoreaCompany">
                  <div className="kor">영안모자 한국본사</div>
                  <div className="eng">Korean Headquarters</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/HatBusiness/ProductionCorporation">
                  <div className="kor">직경영사업장</div>
                  <div className="eng">Direct Management Affiliates</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/HatBusiness/SalesCorporation">
                  <div className="kor">위탁경영사업장</div>
                  <div className="eng">Indirect Management Affiliates</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/HatBusiness/History">
                  <div className="kor">주요사업이력</div>
                  <div className="eng">Major business history</div>
                </Link>
              </S.NavItem>
            </div>
            <img src={Arrow} className="down-arrow" alt="" />
          </S.Nav>
          <S.Nav height={"160px"}>
            <S.NavItem>
              <Link to="/HatBusiness/ProductionCorporation">
                <div className="kor">스리랑카법인</div>
                <div className="eng">Sri Lanka company</div>
              </Link>
            </S.NavItem>
            <div className="open-list">
              <S.NavItem className="list-inner-item">
                <Link to="/HatBusiness/ProductionCorporation">
                  <div className="kor">베트남법인</div>
                  <div className="eng">Vietnam company</div></Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/HatBusiness/ProductionCorporation2">
                  <div className="kor">방글라데시법인</div>
                  <div className="eng">Bangladesh company</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/HatBusiness/ProductionCorporation3">
                  <div className="kor">스리랑카법인</div>
                  <div className="eng">Sri Lanka company</div>
                </Link>
              </S.NavItem>
              
              
              {/* <S.NavItem className="list-inner-item">
                <Link to="/HatBusiness/ProductionCorporation4">
                  <div className="kor">인도네시아법인</div>
                  <div className="eng">Indonesia company</div>
                </Link>
              </S.NavItem> */}
            </div>
            <img src={Arrow} className="down-arrow" alt="" />
          </S.Nav>
        </S.PageNavidation>

        <div className="wrap">
          <div className="inner">
            <PageTitle titleko={"스리랑카 법인"} titleeng={"Sri Lanka company"} />
            <div className="page-text">
              <div className="kor"><h2>스리랑카 법인 / YoungAn Int'l Lanka(Pvt) Ltd.</h2></div>
              <div className="eng"><h2>Sri Lanka company / YoungAn Int'l Lanka(Pvt) Ltd.</h2></div>
            </div>

            <S.ImgHolderFullsize>
              <img src={Factory1} className="holder-img" alt="" />
                <div className="holder-name">
                  <div className="kor">스리랑카 공장</div>
                  <div className="eng">Sri Lanka Factory 1</div>
                </div>
            </S.ImgHolderFullsize>

           

            <PageTitle titleko={"주요생산제품"} titleeng={"Major Production Products"} />
            <S.ImgHolderFlex className="center">
              <img src={Hat1} alt="" />
              <img src={Hat2} alt="" />
            </S.ImgHolderFlex>
            <PageTitle titleko={"주요이력"} titleeng={"Major History"} />

            <div className="page-text">
              <div className="page-text-flex">
                <div className="page-text-area">
                  <div className="page-text-title">
                    <div className="kor"><h2>YA-SLI 법인</h2></div>
                    <div className="eng"><h2>Company Profile of YA-SLI (Factory 3)</h2></div>
                  </div>
                  <div className="kor">
                    YoungAn Int’l Lanka(Pvt) Ltd.
                    <br />
                    말와따(Malwatta) 3공장
                    <br />
                    법인 설립 : 1987년 12월
                  </div>
                  <div className="eng">
                    YoungAn Int’l Lanka(Pvt) Ltd.
                    <br />
                    Factory 3 in Malwatta
                    <br />
                    Establishment : Dec. 1987
                  </div>

                </div>
                
              </div>{" "}
              <div className="kor">
                ※ 종합 햇 생산공장 / 정통 및 패션햇 생산공장 <br />
                ※ 주요 생산 품목 : 사파리햇, 드레스햇/캡, 롤업 버켓햇, 아웃백햇, 베이스볼캡, 바이저
                <br /> ※ 생산라인 : 9라인 / 년 생산캐파 : 120,000 타
              </div>
              <div className="eng">
                ※ Comprehensive hat production factory / Authentic hat and Fashion hat production factory <br />
                ※ Major Production Products : Safari hat, Dress hat/cap, Roll-up bucket hat, Outback hat, Baseball cap, Visor <br />
                ※ Number of Production Line : 9 Lines / Yearly Production Capacity : 120,000dz
              </div>


            </div>
          </div>
        </div>
      </section>
    </S.Page>
  );
};

export default ProductionCorporation;
